import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Button, Chip } from '../../components/common';
import DataGrid from '../../components/DataGrid/DataGrid';
import { simulation } from '../../utils/api';

export default function Simulation(props) {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [selection, setSelection] = useState([]);
  const [selectionData, setSelectionData] = useState([]);

  const columns = [
    {
      field: 'id',
      headerName: 'Symulacja',
      hideable: false,
      filterable: false,
      getApplyQuickFilterFn: undefined,
      align: 'left',
      headerAlign: 'left',
      renderCell: (params) => {
        return (
          <>
            <Chip
              key={params.row.id}
              label={`S ${params.row.id}`}
              onClick={() =>
                history.push(`/dashboard/simulation/${params.row.id}`)
              }
            />
          </>
        );
      },
    },
    {
      field: 'name',
      headerName: 'Nazwa symulacji',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'date',
      headerName: 'Data wykonania',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return moment.unix(params.value / 1000).format('DD-MM-YYYY');
      },
    },
    {
      field: 'user',
      headerName: 'Użytkownik',
      minWidth: 150,
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.bankUserName} ${params.row.bankUserSurname}`;
      },
    },
    {
      field: 'description',
      headerName: 'Opis symulacji',
      minWidth: 150,
      flex: 1,
    },
  ];

  const updateSimulations = () => {
    simulation
      .simple()
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    updateSimulations();
  }, []);

  const handleSelectionChange = (newSelection) => {
    setSelection(newSelection);
    const selectionDataFiltered = data?.filter((param) => {
      if (newSelection.includes(param.id)) return param;
      else return null;
    });
    setSelectionData(selectionDataFiltered);
  };

  const deleteSimulation = () => {
    simulation
      .delete(selection[0])
      .then((res) => {
        updateSimulations();
      })
      .catch((err) => {});
  };

  return (
    <>
      <Box sx={{ mt: 10 }}>
        <Button
          variant="contained"
          onClick={() => history.push('/dashboard/add-simulation')}
        >
          DODAJ SYMULACJĘ
        </Button>
        <Button
          redDelete
          variant="contained"
          sx={{ ml: 4 }}
          disabled={selection.length !== 1}
          onClick={() => deleteSimulation()}
        >
          USUŃ SYMULACJĘ
        </Button>
        <DataGrid
          toolbar
          checkboxSelection
          columnData={columns}
          autoHeight
          onSelectionModelChange={handleSelectionChange}
          selectionModel={selection}
          rowData={data?.sort((a, b) => a.id - b.id)}
          sx={{ boxShadow: 3, mt: 2 }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />
      </Box>
    </>
  );
}
